module.exports = __webpack_public_path__ + "static/17-d004107b3df1e6de933917a01b32f50f.png";